module.exports = __webpack_public_path__ + "54cf98f5/img/note-list-icon.961c1485.svg";